import React from 'react';

export const StakeTableRow = ({
  slots: { toggle, name, kind, wiseQuantity, stake, value, acqCost, profit, share, actions, comment },
  component: Component,
  renderwiseQuantity = false,
}: {
  slots: {
    toggle: React.ReactNode;
    name: React.ReactNode;
    kind: React.ReactNode;
    wiseQuantity: React.ReactNode;
    stake: React.ReactNode;
    value: React.ReactNode;
    acqCost: React.ReactNode;
    profit: React.ReactNode;
    share: React.ReactNode;
    comment: React.ReactNode;
    actions: React.ReactNode;
  };
  // any is expected here
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: React.ElementType<any, 'td' | 'th'>;
  renderwiseQuantity?: boolean;
}) => {
  return (
    <tr>
      <Component width="20px">{toggle}</Component>
      <Component>{name}</Component>
      <Component>{kind}</Component>
      {renderwiseQuantity && <Component>{wiseQuantity}</Component>}
      <Component>{stake}</Component>
      <Component>{value}</Component>
      <Component>{acqCost}</Component>
      <Component>{profit}</Component>
      <Component>{share}</Component>
      <Component>{comment}</Component>
      <Component>{actions}</Component>
    </tr>
  );
};
